import { render, staticRenderFns } from "./PdfModal.vue?vue&type=template&id=08d79b6c"
import script from "./PdfModal.vue?vue&type=script&lang=js"
export * from "./PdfModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d79b6c')) {
      api.createRecord('08d79b6c', component.options)
    } else {
      api.reload('08d79b6c', component.options)
    }
    module.hot.accept("./PdfModal.vue?vue&type=template&id=08d79b6c", function () {
      api.rerender('08d79b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/PdfModal.vue"
export default component.exports